<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-12">
                                <h4 class="card-title float-left"> Товары</h4>
                                <router-link tag="button" class="btn btn-success float-right" to="/product/new">Добавить
                                </router-link>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="pull-left">
                                    <label>&nbsp;</label>
                                    <div class="input-group search-box" style="width: 500px;">
                                        <input class="form-control" type="text" placeholder='Search'
                                               v-model="filter.search"
                                               @keypress.enter="onSearchProduct">
                                        <div class="input-group-append">
                                            <button class="btn btn-info" @click="onSearchProduct">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 d-flex align-items-center justify-content-end">
                                <div class="pull-right">
                                    <small style="color: gray;" class="ml-3" v-if="results"> Общий: {{results.total}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div class="row">
                            <div class="col-12 col-md-2">
                                <div class="form-group">
                                    <label>Категория</label>
                                    <v-select v-model="category" label="name"
                                              :options="categories"
                                              :filterable="false"
                                              @search="onCategorySearch"
                                              @search:focus="onCategoryFocus()"
                                              @input="onCategoryChoose"></v-select>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group">
                                    <label>Пользователь</label>
                                    <v-select label="name"
                                              :options="variationMake"
                                              :filterable="false"
                                              v-model="make"
                                    >
                                        <span slot="no-options">Маълумот мавжуд эмас</span>
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group">
                                    <label>Пользователь</label>
                                    <v-select label="name"
                                              :options="variationModel"
                                              :filterable="false"
                                              v-model="model"
                                    >
                                        <span slot="no-options">Маълумот мавжуд эмас</span>
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group">
                                    <label>Пользователь</label>
                                    <v-select label="name"
                                              :options="variationPosition"
                                              :filterable="false"
                                              v-model="position"
                                    >
                                        <span slot="no-options">Маълумот мавжуд эмас</span>
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group">
                                    <label>Пользователь</label>
                                    <input type="number" class="form-control" v-model="productionYear" placeholder="Название">
                                </div>
                            </div>
                            <div class="col-12 col-md-2 d-flex align-self-end justify-content-end mb-3">
                                <toggle-button class="mr-2" v-model="publish"
                                               :labels="{checked: 'да', unchecked: 'нет'}"
                                               :color="{checked: '#42A5F5', unchecked: '#B0BEC5'}"
                                               :switchColor="{checked: '#1E88E5', unchecked: '#90A4AE'}" :sync="true"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-2">
                                <div class="form-group">
                                    <label>Тип действия</label>
                                    <select class="form-control" v-model="actionType">
                                        <option value="CREATED">Создано</option>
                                        <option value="UPDATED">Обновлено</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <label>Из</label>
                                <div class="form-group">
                                    <date-picker value-type="format" v-model="startDate" format="DD/MM/YYYY"
                                                 lang="ru"></date-picker>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <label>До</label>
                                <div class="form-group">
                                    <date-picker value-type="format" v-model="endDate" format="DD/MM/YYYY"
                                                 lang="ru"></date-picker>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group">
                                    <label>Пользователь</label>
                                    <v-select label="name"
                                              :options="users"
                                              :filterable="false"
                                              v-model="user"
                                              @search:focus="onUserFocus"
                                              @search="onUserSearch"
                                    >
                                        <span slot="no-options">Маълумот мавжуд эмас</span>
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">

                            </div>
                            <div class="col-12 col-md-2 d-flex align-self-end justify-content-end mb-3">
                                <button class="btn btn-info m-0" @click="onSearchProduct" style="padding: 9px 16px;">Поиск</button>
                            </div>
                        </div>
                        <hr/>
                    </div>
                    <div class="card-body table-responsive">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th width="2%">ID</th>
                                <th width="8%">Изображение</th>
                                <th width="15%">Название</th>
                                <th width="10%" class="text-right">Цена</th>
                                <th width="15%">Категория</th>
                                <th width="15%">Регион</th>
                                <th width="15%" class="d-none d-md-table-cell">Создано</th>
                                <th width="15%" class="d-none d-md-table-cell">Обновлено</th>
                                <th class="d-none d-md-table-cell text-center">Опубликовано</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody v-if="!loading && results && results.data">
                            <tr v-for="result in results.data" :key="result.id">
                                <td>{{result.id}}</td>
                                <td>
                                    <img :src="result.photo.url" style="max-width: 100px;max-height: 100px" v-if="result.photo && result.photo.url"/>
                                </td>
                                <td>{{result.name}}</td>
                                <td class="text-right">
                                    {{result.price | currency('', 0, { thousandsSeparator: ' ' })}} {{result.priceUnit && result.priceUnit.symbol ? result.priceUnit.symbol : ''}}
                                </td>
                                <td>{{result.category ? result.category.name : ''}}</td>
                                <td>{{result.region ? result.region.name : ''}}</td>
                                <td class="d-none d-md-table-cell">
                                    <div v-if="result.createdBy">
                                        <div v-if="result.createdBy.name && result.createdBy.name.length > 0">{{result.createdBy.name}}</div>
                                        <div v-else-if="result.createdBy.phone && result.createdBy.phone.length > 0">{{result.createdBy.phone}}</div>
                                    </div>
                                    <div v-if="result.createdDate">{{result.createdDate}}</div>
                                </td>
                                <td class="d-none d-md-table-cell">
                                    <div v-if="result.updatedBy">
                                        <div v-if="result.updatedBy.name && result.updatedBy.name.length > 0">{{result.updatedBy.name}}</div>
                                        <div v-else-if="result.updatedBy.phone && result.updatedBy.phone.length > 0">{{result.updatedBy.phone}}</div>
                                    </div>
                                    <div v-if="result.updatedDate">{{result.updatedDate}}</div>
                                </td>
                                <td class="d-none d-md-table-cell text-center">
                                    {{result.publish ? 'да' : 'нет'}}
                                </td>
                                <td>
                                    <div class="btn-group btn-group-sm">
                                        <router-link :to="'/product/edit/' + result.id" tag="button" class="btn btn-info">
                                            <i class="fa fa-pencil"></i>
                                        </router-link>
                                        <button class="btn btn-danger" @click="deleteDialog(result)">
                                            <i class="fa fa-remove"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">Нет данных</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.pageCount && results.pageCount > 1 ">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page" :per-page="filter.pageSize" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import {BPagination} from 'bootstrap-vue';
    import ToggleButton from 'vue-js-toggle-button/src/Button';
    import FilterModel from './../../shared/filter';
    // import AdvancedFilterModel from './../../shared/filters/advancedFilter';
    import DatePicker from 'vue2-datepicker';

    export default {
        name: "ProductList",
        components: {
            'b-pagination': BPagination,
            DatePicker,
            ToggleButton
        },
        data() {
            return {
                loading: false,
                filter: new FilterModel(),
                userFilter: new FilterModel(),
                results: null,
                user: null,
                users: [],
                categories: [],
                category: null,
                variations: [],
                variationMake: [],
                variationModel: [],
                variationPosition: [],
                make: null,
                model: null,
                position: null,
                actionType: 'CREATED',
                startDate: null,
                endDate: null,
                productionYear: null,
                publish: true
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.get('product', this.filter.asQuery())
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page = page;
                this.initList();
            },
            deleteProduct(product) {
                this.$http.delete('product/' + product.id)
                    .then(() => {
                        this.initList();
                    }, () => {
                        this.$swal({
                            title: 'Ошибка',
                            text: 'Ошибка при удалении товар',
                            type: 'error'
                        });
                    });
            },
            deleteDialog(item) {
                this.$swal({
                    title: 'Удалить?',
                    text: 'Вы действительно хотите удалить этот товар?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Удалить',
                    cancelButtonText: 'Отменить',
                    confirmButtonColor: '#E5343D'
                }).then((result) => {
                    if (result.value) {
                        this.deleteProduct(item);
                    }
                });
            },
            onSearchProduct() {
                this.filter.page = 1;
                this.filter.userId = this.user ? this.user.id : null;
                this.filter.startDate = this.startDate ? this.startDate : null;
                this.filter.endDate = this.endDate ? this.endDate : null;
                this.filter.actionType = this.actionType ? this.actionType: null;
                this.filter.category = this.category ? this.category.id: null;
                this.filter.make = this.make ? this.make.code: null;
                this.filter.model = this.model ? this.model.code: null;
                this.filter.position = this.position ? this.position.code: null;
                this.filter.productionYear = this.productionYear ? this.productionYear: null;
                this.filter.publish = this.publish;
                this.initList();
            },
            onUserFocus() {
                if (this.users.length === 0 || !this.user) {
                    this.userFilter.search = '';
                    this.$http.post('user/search', this.userFilter)
                        .then(res => {
                            this.users = res.data.data;
                        }, err => {
                            console.log(err);
                        });
                }
            },
            onUserSearch(searchTxt, loading) {
                loading(true);
                this.userFilter.search = searchTxt;
                this.$http.post('/user/search', this.userFilter)
                    .then(res => {
                        this.users = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCategorySearch(searchTxt, loading) {
                loading(true);
                this.$http.post('category/choose', {search: searchTxt})
                    .then(res => {
                        this.categories = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCategoryFocus() {
                this.$http.post('category/choose', {search: ''})
                    .then(res => {
                        this.categories = res.data.data;

                    }, err => {
                        console.log(err);
                    });
            },
            onCategoryChoose() {
                if (this.category && this.category.id && this.category.id > 0) {
                    this.$http.get('category/' + this.category.id + '/variations/' + (this.id ? this.id : 0))
                        .then(res => {
                            if (res.data) {
                                this.variations = res.data;
                                let variationMakeList = [];
                                let variationModelList = [];
                                let variationPositionList = [];
                                this.variations.forEach((variation) => {
                                    if (variation.code === "make") {
                                        variationMakeList = variation.items;
                                    }
                                    if (variation.code === "model") {
                                        variationModelList = variation.items;
                                    }
                                    if (variation.code === "position") {
                                        variationPositionList = variation.items;
                                    }
                                });
                                this.variationMake = variationMakeList;
                                this.variationModel = variationModelList;
                                this.variationPosition = variationPositionList;

                            }
                        }, err => {
                            console.log(err);
                        });
                }
            },
        },
        created() {
            this.initList();
        }
    }
</script>

<style scoped>

</style>